export const DataPanelModes = {
  PROPERTY_MODE: 'propertyMode'
};